import React, { CSSProperties, ReactNode } from "react";
import styles from "./gradient-border-container.module.scss";

const cssClassName = "gradient-border-container";

interface GradientBorderContainerProps {
  children: ReactNode;
  radius?: number;
}

export const GradientBorderContainer = ({
  children,
  radius = 4,
}: GradientBorderContainerProps) => {
  const styleVars = {
    "--radius": `${radius}px`,
  } as CSSProperties;
  return (
    <div className={styles[cssClassName]} style={styleVars}>
      {children}
    </div>
  );
};
